import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { IGiftRecipientsData } from '../../../models';
import { CustomComponent, IOrderDelivery } from '@cakeiteasy/web-utils';
import { debounceTime } from 'rxjs/operators';

@Component({
  standalone: false,
  selector: 'gift-delivery-recipients-form',
  templateUrl: './gift-delivery-recipients-form.component.html',
  styleUrls: ['./gift-delivery-recipients-form.component.scss']
})
export class GiftDeliveryRecipientsFormComponent extends CustomComponent implements OnInit {
  @Input() delivery: IOrderDelivery;
  @Input() countryCode: string;
  @Output() onDataChanged = new EventEmitter<IGiftRecipientsData>();
  @Output() onValidChange = new EventEmitter<boolean>();

  public recipientsForm: FormGroup;

  constructor(private _fb: FormBuilder) {
    super();
  }

  ngOnInit() {
    this._initForm();

    if (this.delivery) {
      this.recipientsForm.patchValue(this.delivery);
      this.onValidChange.emit(this.recipientsForm.valid);
    }

    this._subscribe();
  }

  private _initForm() {
    this.recipientsForm = this._fb.group({
      deliveryUserName: ['', [Validators.required, Validators.maxLength(32)]],
      deliveryPhone: ['', [Validators.required, Validators.maxLength(32)]],
      deliveryEmail: ['', [Validators.email, Validators.maxLength(128)]],
      messageToRecipient: ['', [Validators.maxLength(512)]],
    });
  }

  private _subscribe() {
    this.addSubscriber(this.recipientsForm.valueChanges
      .pipe(debounceTime(500))
      .subscribe(data => {
        this.onDataChanged.emit(data);
        this.onValidChange.emit(this.recipientsForm.valid);
      }));
  }
}
